import { DepartmentResponse, UploadDepartmentCoverPayload, createTeamsPayload, updateTeamsPayload } from '../features/department/departmentTypes';
import { del, get, post, put } from '../utils/api';
import { formatUrl } from '../utils/urlFormatter';


const fetch_departmenet = '/{0}/department.list';
const create_locations = '/{0}/department.add';
const fetch_department_by_id = '/{0}/{1}/department.detail';
const delete_teams = '/team/{0}/{1}/deleteTeam';
const update_department = '/{0}/{1}/department.update';
const fetch_locations_status = '/{0}/department.list';
const upload_department_cover = '/{0}/{1}/department.updateCoverImage';
const upload_department_logo = '/{0}/{1}/department.updateImage';

const credentialsConfig = {
  withCredentials: true,
}


export const fetchDepartmentData = async (baseId: number): Promise<DepartmentResponse> => {
  const fetch_location_data = formatUrl(fetch_departmenet, [baseId]);
  return get<DepartmentResponse>(fetch_location_data, credentialsConfig);
};


export const fetchLocationDataStatus = async (baseId: number, status?: string): Promise<DepartmentResponse> => {
  let fetch_location_data = formatUrl(fetch_locations_status, [baseId]);
  if (status) {
    fetch_location_data += `?status=${status}`;
  }
  return get<DepartmentResponse>(fetch_location_data, credentialsConfig);
};


export const createDepartmentData = async (data: createTeamsPayload, userId: number): Promise<DepartmentResponse> => {
  const base_create_location = formatUrl(create_locations, [userId]);
  return post<DepartmentResponse>(base_create_location, data, credentialsConfig);
};


export const fetchDepartmentById = async (baseId: number, departmentId: number): Promise<DepartmentResponse> => {
  const fetchcreate_data = formatUrl(fetch_department_by_id, [baseId, departmentId]);
  return get<DepartmentResponse>(fetchcreate_data, credentialsConfig);
};


export const uploadDepartmentCoverData = async (data: UploadDepartmentCoverPayload, userId: number, departmentId: number): Promise<DepartmentResponse> => {
  const update_base_url = formatUrl(upload_department_cover, [userId, departmentId]);
  const formData = new FormData();
  formData.append('image', data.image);
  return post<DepartmentResponse>(update_base_url, formData, {
    ...credentialsConfig,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};


export const uploadDepartmentLogoData = async (data: UploadDepartmentCoverPayload, userId: number, departmentId: number): Promise<DepartmentResponse> => {
  const update_base_url = formatUrl(upload_department_logo, [userId, departmentId]);
  const formData = new FormData();
  formData.append('image', data.image);
  return post<DepartmentResponse>(update_base_url, formData, {
    ...credentialsConfig,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};


///////////////////


export const deleteTeamsData = async (id: number, baseId: number): Promise<DepartmentResponse> => {
  const delete_teams_data = formatUrl(delete_teams, [baseId, id]);
  return del<DepartmentResponse>(delete_teams_data, credentialsConfig);
};


export const updateLocationData = async ( baseId: number, departmentId: number, data: updateTeamsPayload): Promise<DepartmentResponse> => {
  const update_teams_data = formatUrl(update_department, [baseId, departmentId]);
  return put<DepartmentResponse>(update_teams_data, data, credentialsConfig);
};
